export const appDefId = 'df892fe9-626f-44c9-a328-e29f93880b38';
export const widgetId = 'f6aa0c93-74ae-415c-a5e3-1bfc7c747bf4';
export const widgetName = 'PaymentMethodsBannerWidget';
